export default [
    {
        path: "app-error-logs",
        name: "appErrorLogs",
        component: () =>
            import(
                /* webpackChunkName: "AppErrorlogs" */ "../pages/appErrorLog/AppErrorLogs.vue"
            ),
        meta: {
            title: `App Error Logs`,
        },
    },
    
];
